import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../lib/axios.js";

/**
 * Hook to fetch end-of-season awards for a league.
 * @param {string} leagueId - League ID
 * @param {Object} options
 * @param {number} [options.season] - Season number (backend defaults to the latest)
 * @param {boolean} [options.enabled] - Extra enabled guard
 * @returns {Object} - Query result with the season awards payload
 */
export const useGetSeasonAwards = (leagueId, { season, enabled = true } = {}) => {
  return useQuery({
    queryKey: ["season-awards", leagueId, season ?? "current"],
    queryFn: async () => {
      const params = season != null ? { season } : undefined;
      const response = await axiosInstance.get(
        `/leagues/${encodeURIComponent(String(leagueId))}/season-awards`,
        { params }
      );
      return response.data;
    },
    enabled: !!leagueId && enabled,
    staleTime: 5 * 60 * 1000,
  });
};
